module.exports = __webpack_public_path__ + "static/img/charcolor.8230a874.png";